import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Projects } from "../../../ProjectData";

function Recent({ changeProject }) {
  return (
    <div className="scroll-wrapper">
      <div className="project-list">
        <h2 className="mobile-title">Recent Work:</h2>
        {Projects.map((project) => (
          <Fragment key={project.key}>
            <Link
              className="project-titles"
              to={`/recent/${project.route}`}
              onClick={() => changeProject(project.key)}
            >
              {project.title}
            </Link>
            <br />
          </Fragment>
        ))}
        <br />
      </div>
    </div>
  );
}

export default Recent;
